import { accessRole } from "../../../../../helpers/access_role"
import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"

import TableActiveComponent from './Components/TableActiveComponent'
import TableInactiveComponent from './Components/TableInactiveComponent'

const IndexView = (props) => {
    const [activeTab, setActiveTab] = useState("1")
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadActive = () => activeRef.current && activeRef.current.setTokenAPI();
    const reloadInactive = () => inactiveRef.current && inactiveRef.current.setTokenAPI();

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                    {accessRole('create') && (
                                        <Link to={`${window.location.pathname}?create`}>
                                            <Button color="primary">
                                                <i className="uil-plus me-1"></i> Tambah Data Kompetensi
                                            </Button>
                                        </Link>
                                    )}
                                </div>
                                <CardTitle>Data Master Kompetensi</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Master Data Kompetensi Penilaian 360
                                </CardSubtitle>
                                <hr />
                                <Nav tabs className="mb-3">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === "1" })}
                                            onClick={() => setActiveTab("1")}
                                        >
                                            Aktif
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === "2" })}
                                            onClick={() => setActiveTab("2")}
                                        >
                                            Tidak Aktif
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <TableActiveComponent
                                            ref={activeRef}
                                            handleInactiveSuccess={reloadInactive}
                                        />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TableInactiveComponent
                                            ref={inactiveRef}
                                            handleActiveSuccess={reloadActive}
                                        />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView
